// test1872
(1872 && 0);
